/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Filter_SearchInputs */

const cs_blog_filter_search = /** @type {(inputs: Blog_Filter_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat články`)
};

const en_blog_filter_search = /** @type {(inputs: Blog_Filter_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search articles`)
};

/**
* | output |
* | --- |
* | "Search articles" |
*
* @param {Blog_Filter_SearchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_filter_search = /** @type {((inputs?: Blog_Filter_SearchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Filter_SearchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_filter_search(inputs)
	return cs_blog_filter_search(inputs)
});